import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./header";
import { Footer } from "./footer";
import '../Styles/layout.scss'

const Layout = () => {

  return (
    <div className='app-wrapper'>
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <div className="footer mt-3">
        <Footer />
      </div>
    </div>)
}

export default Layout;